module.exports = __webpack_public_path__ + "img/yg-background.efb4448.svg";